export const initialFormValues = {
  categoryKey: '',
  totalValue: '',
  observations: ''
}
